import { PkDivider } from '@uefadigital/panenka-react';
import { useTranslation } from 'react-i18next';

const Footnote = () => {
  const { t } = useTranslation();

  return (
    <div pk-theme='light' className='pk-bg--background pk-pt--l pk-text--text-01'>
      <div className='pk-col pk-col--span-12 pk-font-size--s pk-d--flex pk-flex--column pk-justify-content--center pk-align-items--center pk-gap--xs pk-text--center'>
        <PkDivider />
        <span>{t('vote_footnote')}</span>
        <PkDivider />
      </div>
    </div>
  );
};

export default Footnote;
